import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { AgentRunTable } from "@/app/Agents/Components/AgentRunTable";
import { agentRunsRoute } from "@/app/Agents/Routes/agentRoutes";
import { AgentRunKind, AgentRunState } from "@/gql/graphql";
import { useNavigate } from "@tanstack/react-router";

export function AgentRunsScreen() {
  const { agentKind, agentState } = agentRunsRoute.useSearch();
  const navigate = useNavigate({ from: agentRunsRoute.fullPath });

  return (
    <FullPageScreen>
      <AgentRunTable
        kind={agentKind}
        state={agentState}
        onKindChange={(kind?: AgentRunKind) =>
          navigate({ search: (prev) => ({ ...prev, agentKind: kind }) })
        }
        onStateChange={(state?: AgentRunState) =>
          navigate({ search: (prev) => ({ ...prev, agentState: state }) })
        }
      />
    </FullPageScreen>
  );
}
